export enum AvailableTabs {
  GENERAL = 'general',
  STORAGE = 'storage',
  SPAM = 'spam',
  FORWARDS = 'forwards',
  AUTORESPONDER = 'autoresponder',
}
